import { useState, useEffect } from 'react'
import { useApp } from '@/store/AppContext'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { useToast } from '@/hooks/use-toast'

export function SubscriberPaymentDialog({
  subscriberId,
  onClose,
}: {
  subscriberId: string | null
  onClose: () => void
}) {
  const { subscribers, addSubscriberPayment } = useApp()
  const { toast } = useToast()

  const sub = subscribers.find((s) => s.id === subscriberId)

  const [amount, setAmount] = useState(0)
  const [method, setMethod] = useState('Pix')
  const [refMonth, setRefMonth] = useState(new Date().toISOString().slice(0, 7))

  useEffect(() => {
    if (sub && subscriberId) {
      setAmount(sub.monthlyFee)
      setRefMonth(new Date().toISOString().slice(0, 7))
      setMethod('Pix')
    }
  }, [sub, subscriberId])

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (!sub) return

    addSubscriberPayment({
      subscriberId: sub.id,
      amount,
      method,
      referenceMonth: refMonth,
    })

    toast({
      title: 'Pagamento Registrado',
      description: 'O status do mensalista foi atualizado para Ativo.',
    })
    onClose()
  }

  return (
    <Dialog open={!!subscriberId} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-[400px]">
        <DialogHeader>
          <DialogTitle>Registrar Pagamento</DialogTitle>
          <DialogDescription>
            Confirme o recebimento da mensalidade de {sub?.name}.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4 pt-2">
          <div className="space-y-2">
            <Label>
              Mês de Referência <span className="text-destructive">*</span>
            </Label>
            <Input
              type="month"
              required
              value={refMonth}
              onChange={(e) => setRefMonth(e.target.value)}
            />
          </div>
          <div className="space-y-2">
            <Label>
              Valor Recebido (R$) <span className="text-destructive">*</span>
            </Label>
            <Input
              type="number"
              step="0.5"
              required
              value={amount}
              onChange={(e) => setAmount(Number(e.target.value))}
            />
          </div>
          <div className="space-y-2">
            <Label>
              Forma de Pagamento <span className="text-destructive">*</span>
            </Label>
            <Select value={method} onValueChange={setMethod}>
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="Dinheiro">Dinheiro</SelectItem>
                <SelectItem value="Pix">Pix</SelectItem>
                <SelectItem value="Cartão">Cartão</SelectItem>
                <SelectItem value="Transferência">
                  Transferência Bancária
                </SelectItem>
              </SelectContent>
            </Select>
          </div>
          <Button type="submit" className="w-full mt-4 font-bold h-12">
            Confirmar Recebimento
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  )
}
